import { render, staticRenderFns } from "./EmployeeGrid.vue?vue&type=template&id=0a566828&"
import script from "./EmployeeGrid.vue?vue&type=script&lang=js&"
export * from "./EmployeeGrid.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports